import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../municipal-waste-disposal.routes';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  MunicipalWasteDisposalDeclarationSubjectForm
} from './forms/municipal-waste-disposal-declaration-subject.form';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { updateLargeFamilyCards } from '../../../../../../store/actions/application.actions';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { NgxMaskDirective } from 'ngx-mask';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { LargeFamilyFormComponent } from './components/large-family-form/large-family-form.component';

@Component({
  selector: 'app-municipal-waste-disposal-declaration-subject-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    SpinnerComponent,
    DatePickerComponent,
    AlertComponent,
    LargeFamilyFormComponent
  ],
  providers: [MunicipalWasteDisposalDeclarationSubjectForm],
  templateUrl: './municipal-waste-disposal-declaration-subject-section.component.html'
})
export class MunicipalWasteDisposalDeclarationSubjectSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public form: MunicipalWasteDisposalDeclarationSubjectForm = inject(MunicipalWasteDisposalDeclarationSubjectForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateLargeFamilyCards({
        currentApp,
        payload: this.form.toWriteModel(),
        cards: this.form.cards,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
